import { useEffect, useState } from "react";
import { Button, InputBase } from "@mui/material";

export default function SearchInput({
  defaultValue,
  placeholder,
  normalize,
  onSearch,
  inputSx,
  buttonSx,
  buttonText = "搜索",
  buttonColor,
  buttonVariant,
  buttonSize,
  disabled,
}) {
  const [value, setValue] = useState(defaultValue || "");

  useEffect(() => {
    setValue(defaultValue || "");
  }, [defaultValue]);

  function normalizeValue(v) {
    return normalize ? normalize(v) : v;
  }

  function handleSearch(e) {
    e && e.preventDefault && e.preventDefault();
    const v = normalizeValue(value);
    if (v !== "") {
      onSearch && onSearch(v);
    }
  }

  return (
    <>
      <InputBase
        sx={inputSx}
        placeholder={placeholder}
        value={value}
        disabled={disabled}
        onChange={(e) => setValue(normalizeValue(e.target.value))}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            handleSearch(e);
          }
        }}
      />
      <Button
        color={buttonColor}
        variant={buttonVariant}
        size={buttonSize}
        disabled={disabled}
        onClick={handleSearch}
        sx={buttonSx}
      >
        {buttonText}
      </Button>
    </>
  );
}

